import React from 'react'
import { useHistory } from 'react-router-dom'
import '../../fonts/fonts.css'
import SideBar from '../SideBar/index'
import { Bg, MainLayout, ContentLayout } from '../CartPage/styledComponents'
import {
  PageWrapper,
  PageHeader, PageIconBox, PageIconImg, PageTitle, PageSubtitle,
  StatusPage, GradientTitle, StatusSubtitle, StatusBody, StatusBtn,
} from '../Cart/styledComponents'
import shoppingBagIcon from '../../images/icon-shopping-bag.png'

const CartCancelled = () => {
  const history = useHistory()

  return (
    <Bg>
      <SideBar />
      <MainLayout>
        <ContentLayout>
          <PageWrapper>
            <PageHeader>
              <PageIconBox>
                <PageIconImg src={shoppingBagIcon} alt='' />
              </PageIconBox>
              <div>
                <PageTitle>Mon panier</PageTitle>
                <PageSubtitle>Repartez tout·e équipé·e</PageSubtitle>
              </div>
            </PageHeader>

            <StatusPage>
              <GradientTitle>Paiement annulé.</GradientTitle>
              <StatusSubtitle>Vous avez annulé votre paiement.</StatusSubtitle>
              <StatusBody>
                Votre panier est intact. Vous pouvez reprendre votre commande
                quand vous le souhaitez.
              </StatusBody>
              <StatusBtn onClick={() => history.push('/cart')}>
                Retourner au panier
              </StatusBtn>
            </StatusPage>

          </PageWrapper>
        </ContentLayout>
      </MainLayout>
    </Bg>
  )
}

export default CartCancelled
